export var CreditCardBrands = {
    VISA: 'VISA',
    MA: 'MA',
    AMEX: 'AMEX',
    DISC: 'DISC',
    HDCOM: 'HDCOM',
    HDCON: 'HDCON',
    PROP: 'PROP',
    PROX: 'PROX',
};
